import { useEffect, useState } from 'react';
import { Icon } from '../../../../layout/Icon.jsx';
import { toast } from '../../../../shared/useToast.js';
import { useResetPassword } from '../../hooks/useUserMutations.js';

export function ResetPasswordModal({ open, user, onClose }) {
  const reset = useResetPassword();
  const [pwd, setPwd] = useState('');
  const [stage, setStage] = useState('confirm'); // confirm | done

  useEffect(() => {
    if (open) {
      setStage('confirm');
      setPwd('');
    }
  }, [open]);

  if (!open) return null;

  async function doReset() {
    if (!user) return;
    try {
      const res = await reset.mutateAsync(user._id || user.id);
      const newPwd = res?.password || res?.newPassword || res?.data?.password;
      if (newPwd) {
        setPwd(newPwd);
        setStage('done');
      } else {
        toast.success('تم إرسال كلمة المرور إلى المستخدم');
        onClose?.();
      }
    } catch {
      /* error toast handled by mutation */
    }
  }

  function copyPwd() {
    if (!pwd) return;
    navigator.clipboard?.writeText(pwd);
    toast.success('تم النسخ');
  }

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center"
      style={{ background: 'rgba(0,0,0,.45)' }}
    >
      <div className="card p-5 w-[460px] space-y-3" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="text-[15px] font-bold">إعادة تعيين كلمة المرور</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>

        {stage === 'confirm' ? (
          <>
            <div className="text-[13px] text-ink-2">
              سيتم توليد كلمة مرور جديدة للمستخدم{' '}
              <b>{user?.fullName || user?.username}</b>. لن تظهر هذه الكلمة سوى مرة واحدة.
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <button type="button" className="btn" onClick={onClose} disabled={reset.isPending}>
                إلغاء
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={doReset}
                disabled={reset.isPending}
              >
                {reset.isPending ? 'جاري...' : 'توليد كلمة مرور'}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="text-[13px] text-ink-2">
              تم توليد كلمة المرور بنجاح. انسخها وشاركها مع المستخدم — لن تظهر مرة أخرى.
            </div>
            <div className="flex items-center gap-2 p-3 rounded-[10px] bg-paper-2 border border-line">
              <code className="font-mono text-[15px] font-bold flex-1 break-all">{pwd}</code>
              <button type="button" className="btn" onClick={copyPwd}>
                نسخ
              </button>
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <button type="button" className="btn btn-primary" onClick={onClose}>
                تم
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
